import { render, staticRenderFns } from "./exportButton_v2.vue?vue&type=template&id=f52a4776"
import script from "./exportButton_v2.vue?vue&type=script&lang=js"
export * from "./exportButton_v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports